import React, { ReactElement } from 'react';
import { Form, Input } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { Rule } from 'antd/lib/form';

interface Props {
  disabled?: boolean;
  label?: string;
  placeholder?: string;
}

const rules: Rule[] = [
  { required: true, message: 'Email not valid' },
  { type: 'email', message: 'Email not valid' },
];

export function FieldEmail(props: Props): ReactElement {
  const { disabled, label, placeholder } = props;
  return (
    <Form.Item name="email" label={label ?? 'Email'} rules={rules}>
      <Input
        type="email"
        prefix={<UserOutlined />}
        data-testid="email-input"
        disabled={disabled}
        placeholder={placeholder ?? 'Type email'}
      />
    </Form.Item>
  );
}
